const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNosql(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(1.176471%,13.725491%,18.039216%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12.999219 -1.001953 L 56.000781 -1.001953 C 63.728516 -1.001953 70.001953 5.271484 70.001953 12.999219 L 70.001953 56.000781 C 70.001953 63.728516 63.728516 70.001953 56.000781 70.001953 L 12.999219 70.001953 C 5.271484 70.001953 -1.001953 63.728516 -1.001953 56.000781 L -1.001953 12.999219 C -1.001953 5.271484 5.271484 -1.001953 12.999219 -1.001953 Z M 12.999219 -1.001953 ",
    transform: "matrix(0.273973,0,0,0.273973,0.547945,0.547945)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.176471%,13.725491%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 15.394531 6.921875 L 9.519531 6.4375 L 9.519531 13.5625 L 15.394531 13.078125 Z M 15.394531 6.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.745098%,28.235295%,36.862746%)",
      fillOpacity: 1
    },
    d: "M 4.605469 6.921875 L 4.605469 13.078125 L 10 13.5625 L 10 6.4375 Z M 4.605469 6.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.745098%,28.235295%,36.862746%)",
      fillOpacity: 1
    },
    d: "M 16.164062 3.835938 L 10 3.835938 L 9.519531 5.378906 L 10 6.921875 L 16.164062 6.921875 Z M 16.164062 3.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.745098%,28.235295%,36.862746%)",
      fillOpacity: 1
    },
    d: "M 16.164062 11.542969 L 16.164062 8.457031 L 10 8.457031 L 9.519531 10 L 10 11.542969 Z M 16.164062 11.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(2.745098%,28.235295%,36.862746%)",
      fillOpacity: 1
    },
    d: "M 16.164062 16.164062 L 16.164062 13.078125 L 10 13.078125 L 9.519531 14.621094 L 10 16.164062 Z M 16.164062 16.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313726%,47.450981%,61.56863%)",
      fillOpacity: 1
    },
    d: "M 3.835938 3.835938 L 10 3.835938 L 10 6.921875 L 3.835938 6.921875 Z M 3.835938 3.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313726%,47.450981%,61.56863%)",
      fillOpacity: 1
    },
    d: "M 3.835938 8.457031 L 10 8.457031 L 10 11.542969 L 3.835938 11.542969 Z M 3.835938 8.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(4.313726%,47.450981%,61.56863%)",
      fillOpacity: 1
    },
    d: "M 3.835938 13.078125 L 10 13.078125 L 10 16.164062 L 3.835938 16.164062 Z M 3.835938 13.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,82.352942%,84.313726%)",
      fillOpacity: 1
    },
    d: "M 11.6875 5.015625 L 15.011719 5.015625 L 15.011719 5.738281 L 11.6875 5.738281 Z M 11.6875 5.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,82.352942%,84.313726%)",
      fillOpacity: 1
    },
    d: "M 11.6875 9.640625 L 15.011719 9.640625 L 15.011719 10.359375 L 11.6875 10.359375 Z M 11.6875 9.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,82.352942%,84.313726%)",
      fillOpacity: 1
    },
    d: "M 11.6875 14.261719 L 15.011719 14.261719 L 15.011719 14.984375 L 11.6875 14.984375 Z M 11.6875 14.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,100%,58.039218%)",
      fillOpacity: 1
    },
    d: "M 4.988281 5.015625 L 5.753906 5.015625 L 5.753906 5.738281 L 4.988281 5.738281 Z M 4.988281 5.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137256%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 6.523438 5.015625 L 7.292969 5.015625 L 7.292969 5.738281 L 6.523438 5.738281 Z M 6.523438 5.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,100%,58.039218%)",
      fillOpacity: 1
    },
    d: "M 4.988281 9.640625 L 5.753906 9.640625 L 5.753906 10.359375 L 4.988281 10.359375 Z M 4.988281 9.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137256%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 6.523438 9.640625 L 7.292969 9.640625 L 7.292969 10.359375 L 6.523438 10.359375 Z M 6.523438 9.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,100%,58.039218%)",
      fillOpacity: 1
    },
    d: "M 4.988281 14.261719 L 5.753906 14.261719 L 5.753906 14.984375 L 4.988281 14.984375 Z M 4.988281 14.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.137256%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 6.523438 14.261719 L 7.292969 14.261719 L 7.292969 14.984375 L 6.523438 14.984375 Z M 6.523438 14.261719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosql);
export default __webpack_public_path__ + "static/media/NOSQL.266a530f4c3b5429b7aa61997e0f2d73.svg";
export { ForwardRef as ReactComponent };